import { ToastVariants } from '@dotcom/crown-ui';
import {
  setIsDeleteConfirmationDialogClosed,
  setIsToasterOpen,
} from '../../../context/app-context/app-context-actions';
import { getIconForLowResImage } from '../../../utils/canvas-utils/get-icon-for-low-res-image';

type deletePhotoParams = {
  currentPhoto: fabric.Image;
  canvas: fabric.Canvas;
  projectId: string;
  deleteImage: (projectId: string, imageName: string) => Promise<any>;
  addAction: (actionType: string, payload: any) => void;
  appDispatch: React.Dispatch<any>;
  errorTitle: string;
  errorMessage: string;
  removeActionType: string;
  retainAsset?: boolean;
};

/**
 * Removes a photo placement, retaining its remote asset when history needs it.
 * This is commonly used to remove a photo from a card face or user zone.
 * @param {deletePhotoParams} params - The parameters for deleting a photo.
 * @returns Whether the placement was removed successfully.
 */
export async function deletePhoto({
  currentPhoto,
  canvas,
  projectId,
  deleteImage,
  addAction,
  appDispatch,
  errorTitle,
  errorMessage,
  removeActionType,
  retainAsset = false,
}: deletePhotoParams): Promise<boolean> {
  const response = retainAsset ? undefined : await deleteImage(projectId, currentPhoto.name || '');
  if (response?.meta?.code >= 400) {
    setIsToasterOpen(appDispatch, {
      title: errorTitle,
      children: errorMessage,
      variant: ToastVariants.Error,
    });
    setIsDeleteConfirmationDialogClosed(appDispatch);
    return false;
  }
  const iconToDelete = getIconForLowResImage(canvas, currentPhoto);
  if (iconToDelete) {
    canvas.remove(iconToDelete);
  }
  canvas.remove(currentPhoto);
  addAction(removeActionType, {
    photo: currentPhoto.data,
  });
  return true;
}
